import { Components, CssVarsTheme, Theme } from "@mui/material";

const Typography = (): Components<
  Omit<Theme, "components" | "palette"> & CssVarsTheme
> => ({
  MuiTypography: {
    defaultProps: {
      variantMapping: {},
    },
  },
});

export default Typography;
